export const BASE_URL = "https://mindcloud.azurewebsites.net";
export const USER_READ_SCOPE = "https://MindCLOUD.onmicrosoft.com/e13939d5-e891-43be-8b48-5d566faed301/UserList.Read";
export const SIGNUP_SIGNIN_FLOW = "https://mindcloud.b2clogin.com/mindcloud.onmicrosoft.com/B2C_1_MindCLOUD_Susi";
export const RESET_FLOW = "https://mindcloud.b2clogin.com/mindcloud.onmicrosoft.com/B2C_1_MindCLOUD_Reset";
export const EDIT_FLOW = "https://mindcloud.b2clogin.com/mindcloud.onmicrosoft.com/B2C_1_MindCLOUD_Edit";
export const SIGNUP_SIGNIN_NAME = "B2C_1_MindCLOUD_Susi";
export const RESET_NAME = "B2C_1_MindCLOUD_Reset";
export const EDIT_NAME = "BB2C_1_MindCLOUD_Edit";
export const AUTHORITY_DOMAIN = "mindcloud.b2clogin.com";
export const CLIENT_ID = "1172a873-a690-4ce1-8f21-afd48d1b3d61"; //UserManagementApp in Azure B2C
